import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../Images/lifelogo.webp";
import LanguageSelector from "./LanguageSelector";
import "../Style/Header.css";
const LIFE_APP_URL = "https://app.be-lifer.com";
function Header() {
  const { t } = useTranslation("lifeIntelligence");
  const [open, setOpen] = useState(false); const close = () => setOpen(false);
  return <header className="header header--intelligence"><div className="header__inner">
    <Link to="/" className="logo-link" aria-label="Life home" onClick={close}><img src={logo} alt="Life" className="CompanyLogo" /></Link>
    <button className="header__menu" aria-label="Toggle navigation" aria-expanded={open} onClick={() => setOpen(!open)}><span /><span /></button>
    <nav className={`header__nav ${open ? "is-open" : ""}`} aria-label="Navigation principale"><a href="/#how-it-works" onClick={close}>{t("nav.how")}</a><a href="/#agents" onClick={close}>{t("nav.agents")}</a><a href="/#use-cases" onClick={close}>{t("nav.cases")}</a><Link to="/security" onClick={close}>{t("nav.security")}</Link><a href="/#pricing" onClick={close}>{t("nav.pricing")}</a></nav>
    <div className="header__actions"><LanguageSelector/><a className="header__login" href={LIFE_APP_URL}>{t("nav.signin")}</a><a className="header__cta" href={LIFE_APP_URL}>{t("nav.get")} <span>↗</span></a></div>
  </div></header>;
}
export default Header;
